export default __webpack_public_path__ + "static/m-yahoo-d44441df413c7598a40d4035a2a9da61.png";